import { Filter, RotateCcw, Search, ListOrdered, Download, Settings, Image } from "lucide-react";
import { useState, useEffect } from "react";
import { StatusFilterPhotoMeter, PhotoMeterItem } from "../../../../model/Hublang";
import { fetchGetPhotoMeterAll } from "../../../../controller/dashboard/Cekmeter";
import { CSV } from "../../../../util/ExportFile";

export const BacaMeter = () => {
  return (
    <>
      BACA METER
    </>
  )
}